<template>
  <div>
    <h1 class="warning-text">
      Warning! Without regular attendee type Registration doen't work. Be sure you created one!
    </h1>
    <v-layout>
      <v-flex xs12 sm6>
        <v-list>
          <v-list-group
            v-for="item in regularAttendeeType"
            :key="item.title"
            no-action
            class="my-2 elevation-5"
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile >
              <v-list-tile-content>
                <v-list-tile-title>{{ item.description }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-layout row>
                  <v-btn color="lime"
                         :disabled="!isWriteAvailable"
                         fab flat
                         @click.stop="openModal(item)"
                  >
                    <v-icon>create</v-icon>
                  </v-btn>
<!-- Delete button was hided only for default regular type! Without default type registration doesn't work. NEED REFACTORING -->
                  <v-btn
                    v-if="!item.isDefault"
                    color="error"
                    :disabled="!isWriteAvailable"
                    fab flat
                    @click.stop="deleted(item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-layout>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm6>
      <v-btn
        class="mx-3 my-3"
        color="primary"
        @click="openModal"
        v-if="isWriteAvailable"
      >
        Add Regular attendee type
      </v-btn>
    </v-flex>

    <v-dialog persistent v-model="modalWindow" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline"> {{typeAction}} Regular attendee type </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout align-center wrap>
              <v-flex xs4>
                <!-- <e-color-picker
                  label="Font Color"
                  v-model="items.fontColor"
                  @colorChange="onColorChange"/> -->
                <content-field
                  label="Display Name"
                  v-model="items.title"
                  @input="$v.items.title.$touch"
                  @blur="$v.items.title.$touch"
                  :error="$v.items.title"
                ></content-field>
                <content-field
                  label="Font family"
                  :error="$v.items.fontFamily"
                  v-model="items.fontFamily"/>
              </v-flex>
              <v-flex xs7 offset-xs1>
                <content-field
                  label="Description"
                  v-model="items.description"
                  @input="$v.items.description.$touch"
                  @blur="$v.items.description.$touch"
                  :error="$v.items.description"
                ></content-field>
                <v-layout row justify-space-around>
                  <v-flex xs4>
                    <content-field
                      label="Font size"
                      :error="$v.items.fontSize"
                      v-model="items.fontSize"/>
                  </v-flex>
                  <v-flex xs4>
                    <v-select
                      label="Font Weight"
                      v-model="items.fontWeight"
                      :items="arrayForWeight"></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" flat @click.stop="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.stop="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  import mixins from '@/utils/mixins'
  import EColorPicker from '@/components/shared/EColorPicker'
  import ContentField from '@/components/shared/ContentField'

  export default {
    name: 'regularAttendeeType',
    mixins: [mixins.isWriteAvailable],
    components: {
      EColorPicker,
      ContentField
    },
    data () {
      return {
        arrayForWeight: [100, 200, 300, 400, 500, 600, 700, 800],
        editedItem: null,
        items: {},
        defaultItem: {
          title: '',
          description: ''
        },
        modalWindow: false,
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    },
    computed: {
      ...mapGetters(['regularAttendeeType']),
      typeAction () {
        return this.editedItem === -1 ? 'Add' : 'Edit'
      }
    },
    watch: {
      modalWindow (val) {
        if (!val) this.close()
      }
    },
    methods: {
      ...mapActions([
        'getRegularAttendeeType',
        'addRegularAttendeeType',
        'editRegularAttendeeType',
        'deleteRegularAttendeeType',
        'showResultErrorMessage'
      ]),
      openModal (item) {
        this.editedItem = this.regularAttendeeType.indexOf(item)
        this.items = Object.assign({}, item)
        // if (!item.fontColor) {
        //   this.items.fontColor = '#000'
        // }
        this.modalWindow = true
      },
      close () {
        this.$v.items.$reset()
        this.modalWindow = false
      },
      save () {
        this.$v.items.$touch()
        if (this.$v.items.$invalid) return
        if (this.editedItem > -1) {
          this.update(this.items)
        } else {
          this.add(this.items)
        }
        this.close()
      },
      // onColorChange (color) {
      //   this.items.fontColor = color.hex
      // },
      async getTypes () {
        await this.getRegularAttendeeType()
      },
      async add (item) {
        try {
          item.isDefault = true
          await this.addRegularAttendeeType({ ...item })
          await this.getTypes()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
      async update (item) {
        try {
          await this.editRegularAttendeeType({ ...item })
          await this.getTypes()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
      async deleted (id) {
        try {
          await this.deleteRegularAttendeeType(id)
          await this.getTypes()
        } catch (err) {
          this.showResultErrorMessage(err)
        }
      },
    },
    beforeMount () {
      this.getTypes()
    },
    validations () {
      return {
        items: {
          title: { required },
          description: { required }
        }
      }
    }
  }
</script>

<style>
  .warning-text {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/regularAttendeeType.vue